export default "__VITE_ASSET__CHlS6AjB__"